import {Injectable} from '@angular/core';
import {TextBase} from '../classes/text-base';

/**
 * @deprecated LazyPhraseService 사용
 */
@Injectable({
  providedIn: 'root'
})
export class RecordText extends TextBase {
  override readonly en = {
    inserted: 'Created Time',
    updated: 'Last Modified',
    updatedAt$: 'Updated at {{this}}'
  };

  override readonly kr = {
    inserted: '등록 시간',
    updated: '수정 시간',
    updatedAt$: '{{this}} 수정'
  };
}
